<template>
  <div class="animated fadeIn list-of-amortization">
    <b-card v-if="showList">
      <div slot="header">Amortization Template/Schedule (Recouring Journal) 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <b-button variant="primary mr-1"  @click="processConfirm()" > <i class="fa fa-play"></i> Process Amortization</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.keterangan" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group >
            <b-input-group-prepend><label>Code Amortization</label></b-input-group-prepend>
              <b-form-input v-model="tblData.kodeamor" placeholder="Code Amortization"></b-form-input>
              <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Account</span></b-input-group-prepend>
              <b-form-input v-model="tblData.namaacc" placeholder="Account Name" style="width:30% !important;"></b-form-input>
          </b-input-group>
          <b-input-group >
            <b-input-group-prepend><label>Reference # (AP/AR)</label></b-input-group-prepend>
              <b-form-input v-model="tblData.nomorap" placeholder="reference number" style="width:20% !important;"></b-form-input>
              <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Outsatnding</span></b-input-group-prepend>
              <b-form-select v-model="tblData.outstand" :plain="true" :options="YesNoAll"></b-form-select>
              <b-input-group-append> <b-button class="btn btn-success ml-3 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
              <b-input-group-append> <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
          </b-input-group>

        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;" >Edit</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;" > Delete</b-dropdown-item>
        </b-dropdown>
      </template>        

        <template v-slot:cell(totalakan)="data">
          {{data.item.totalakan|numFormat}}
        </template>
        <template v-slot:cell(masa)="data">
          <span v-if="(data.item.masa)">{{data.item.masa}} months</span>
        </template>
        <template v-slot:cell(tglawal)="data">
          <span v-if="(data.item.tglawal)">{{data.item.tglawal| moment('DDMMMYYYY')}} </span>
        </template>
        <template v-slot:cell(tglAkhirAmor)="data">
          <span v-if="(data.item.tglAkhirAmor)">{{data.item.tglAkhirAmor| moment('DDMMMYYYY')}} </span>
        </template>
        <template v-slot:cell(nilaisusut)="data">
          {{data.item.Nilaisusut|numFormat}}
        </template>
        <template v-slot:cell(realisasi)="data">
          {{data.item.realisasi|numFormat}}
        </template>
        <template v-slot:cell(outstand)="data">
          {{data.item.outstand|numFormat}}
        </template>
        <template v-slot:cell(Dim1)="data">
          <span v-if="(data.item.Dim1)">{{data.item.Dim1}} | {{data.item.Dim1Txt}}</span>
        </template>
        <template v-slot:cell(Dim2)="data">
          <span v-if="(data.item.Dim2)">{{data.item.Dim2}} | {{data.item.Dim2Txt}}</span>
        </template>
        <template v-slot:cell(Dim3)="data">
          <span v-if="(data.item.Dim3)">{{data.item.Dim3}} | {{data.item.Dim3Txt}}</span>
        </template>
        <template v-slot:cell(Dim4)="data">
          <span v-if="(data.item.Dim4)">{{data.item.Dim4}} | {{data.item.Dim4Txt}}</span>
        </template>
        <template v-slot:cell(Dim5)="data">
          <span v-if="(data.item.Dim5)">{{data.item.Dim5}} | {{data.item.Dim5Txt}}</span>
        </template>
        <template v-slot:cell(Dim6)="data">
          <span v-if="(data.item.Dim6)">{{data.item.Dim6}} | {{data.item.Dim6Txt}}</span>
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Accrued Template Form 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="showProcess" title="Process Amortization" :centered="true"  hide-footer>
            <b-input-group class="p-2">
                <b-input-group-prepend><span class="p-2">Acc. Periode</span></b-input-group-prepend>
                <vue-monthly-picker v-model="filter.periode" dateFormat="MMMM YYYY" :monthLabels="monthLabels" @selected="onChangeMonth" style="width: 340px !important;"></vue-monthly-picker>
            </b-input-group>

            <div style="text-align:right; display:blocked" class="mt-3" >
                <b-button variant="primary" @click="process"><i class="fa fa-play"></i> Process</b-button>
                <b-button variant="success" class="ml-1" @click="printjv" > <i class="fa fa-undo"></i> View Amortization JVs</b-button>
                <b-button variant="danger" class="ml-1" @click="showProcess=false" > <i class="fa fa-close"></i> Close</b-button>
            </div>
    </b-modal>

  </div>
</template>

<style lang="scss">
    .list-of-amortization {
      table {
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
    }
 
</style>


<script>
import toastr from "mini-toastr";
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueMonthlyPicker from 'vue-monthly-picker';
import amortization from "../../apis/amortization";
import dropdown from "../../data/dropdown";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        tgldepr1: { required },
        tgldepr2: { required },
    },
  },   
  data() {
    return {
      showDelConfirm: false,
      pagination: false,
      showList:true,
      showForm:false,
      showFilter:false,
      showProcess:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      filter: { 
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln, 
      },
      model:{},
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        DimCol:'Dim1',        
        sortBy: 'kodeamor',
        sortDesc: true,outstand: ''
      },
      limit:15,
      monthLabels:dropdown.monthLabels,
      YesNoAll: dropdown.YesNoAll
    };
  },
  components: {VueMonthlyPicker,Loading},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          },
          {
            key: "kodeamor",
            label: "Code Amortz.",
            sortable: true
          },
          {
            key: "nomorap",
            label: "Reference",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
            sortable: true
          },
          {
            key: "totalakan",
            label: "Total Amortized",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "masa",
            thStyle: "width:80px",
            label: "Amortiz. Period",
          },
          {
            key: "tglawal",
            thStyle: "width:80px",
            label: "start date",
            sortable: true
          },
          {
            key: "tglAkhirAmor",
            thStyle: "width:80px",
            label: "finish date",
            sortable: true
          },
          {
            key: "Nilaisusut",
            label: "Amortiz per Month",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "realisasi",
            label: "Amortiz. Realization",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "outstand",
            label: "Amortiz. Outstand",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "accountname",
            label: "Account Name",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: dims[i].value,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }

      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },      
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    // data: async function(ctx) {
    //     const filter = this.$store.state.filter;
    //     let filtered=false;
    //     for (var key in filter.amortzList) {
    //         this.tblData[key] = filter.amortzList[key];
    //         filtered=true;
    //     }
    //     if (filtered === true) {
    //       this.showFilter=filtered;
    //       delete filter.amortzList;
    //       this.$store.commit("filter", filter);
    //       // this.$store.commit("filter", {});
    //     }
    //   this.isLoading=true;
    //   this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

    //   const list = await amortization.list(this.tblData);      
    //   this.isLoading=false;

    //   return list;
    // },

    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.amortzList) {
            this.tblData[key] = filter.amortzList[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.amortzList.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.amortzList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await amortization.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await amortization.list(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },

    refresh(ctx) {
      if (this.$refs.table)  this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeamor= '';
        this.tblData.namaacc=  '';
        this.tblData.keterangan=  '';
        this.tblData.vendor=  '';
        this.tblData.DimVal=  '';
        this.refresh();
    },
    saveFilter() {
      const keys = ['sortBy', 'sortDir', 'keterangan', 'DimCol', 'DimVal','nomorap', 'kodeamor', 'namaacc','outstand'];
      let filtered = false;
      const amortzList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              amortzList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          amortzList.page=this.tblData.page;
          amortzList.limit=this.tblData.limit;
          amortzList.sortBy=this.tblData.sortBy;
          amortzList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.amortzList=amortzList;
          this.$store.commit("filter", filter);
      }
    },   
    rowEdit(record) {
      this.rowClicked(record);
      this.edit();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },

    add: function() {
      this.saveFilter();
          router.push({name :'accounting.amortizfrm'});
    },
    edit: function() {
      if (this.model.juamorttkey) {
        this.saveFilter();
        router.push({name :'accounting.amortizfrm', params: { juamorttkey: this.model.juamorttkey}});
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    save: function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              amortization.save(this.frmdata);
              this.closeFrm();    
              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },   
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await amortization.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },

    deleteConfirm() {
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await amortization.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    onSelectLkuVendor(_selected) {
        this.frmdata.vendorinfo = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim();
        this.frmdata.vendor = _selected.vendor_code;
        this.lkuVendorShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
    onChangeMonth: async function (){
        var tgl=this.filter.periode;
        this.filter.tgldepr1=tgl.startOf('month').format('YYYY-MM-DD');
        this.filter.tgldepr2=tgl.endOf('month').format('YYYY-MM-DD');
        console.log('this.filter : ',this.filter);
        this.$forceUpdate();
    },  
    processConfirm: function(){
          this.filter.periode = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
          this.filter.tgldepr1=this.$store.state.user.tglaktif;
          this.filter.tgldepr2= this.filter.periode.format('YYYY-MM-DD');
          this.showProcess=true;
    },    

    process: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {            
         try {
              this.isLoading=true;
              let data= {}
              data.tglakan = moment(this.filter.tgldepr2).format('YYYY-MM-DD');
              await amortization.process(data);
              toastr.success("Complete successfully", "Depreciation Process");
              this.isLoading=false;      
            } catch (error) {
              this.isLoading=false;      
                console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
            }
       }
    },
    printjv: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {            
         try {
              let data= {}
              data.tglakan = moment(this.filter.tgldepr2).format('YYYY-MM-DD');
              this.showReport=true;
              toastr.info('Loading Depreciation Journal Voucher','View Depreciation',10000);
              this.reportUrl= await amortization.printjv(data);

            } catch (error) {
              this.isLoading=false;      
                console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
            }
       }
    },
       
  }
};
</script>
